export default "__VITE_ASSET__BX52qlnL__"